import {css} from '@emotion/react'
import {DqElement} from 'module/Dq/searchDq'
import React, {JSX, MouseEventHandler, useCallback, useState} from 'react'
import {Star, StarBorder} from '@mui/icons-material'
import {isMemorizable} from 'module/Memo/type/Memorizable'
import {useDispatch} from 'react-redux'
import {memoToggleAction} from 'module/Memo/action/MemoAction'

const cssMemo = css`
	font-size: 16px;
	height: 16px;
	width: 16px;
`

interface Props {
	className?: string
	memoKey?: string
	memoSize?: number
	element: DqElement
}

export function MemoOptionIconButton(props: Props) {
	const dispatch = useDispatch()
	const [hover, setHover] = useState(false)
	const {className, memoKey, memoSize, element} = props

	const onClick: MouseEventHandler = useCallback((evt) => {
		if (!memoKey || !memoSize || !isMemorizable(element)) return;
		evt.stopPropagation()
		evt.nativeEvent.stopImmediatePropagation()
		dispatch(memoToggleAction({memoKey, memoSize, element}))
	}, [memoKey, memoSize, element])

	const isMemoActive = !!element.memo

	if (!memoKey || !memoSize || !isMemorizable(element)) return null
	let title: string
	let icon: null | JSX.Element
	if (isMemoActive) {
		title = 'Entfernen'
		icon = !hover ? <Star fontSize={'inherit'}/> : <StarBorder fontSize={'inherit'}/>
	} else {
		title = 'Eintrag merken'
		icon = <Star style={!hover ? {opacity: 0} : {opacity: 1}} fontSize={'inherit'}/>
	}
	return <div
		className={className}
		title={title}
		css={cssMemo}
		onClick={onClick}
		onMouseOver={() => setHover(true)}
		onMouseLeave={() => setHover(false)}
	>
		{icon}
	</div>
}